import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';

const PrivateRouteContainer = (props) => <PrivateRoute {...props} />;

const mapStateTOProps = (state) => ({
  userAuth: state.login.userAuth,
});

export default connect(mapStateTOProps, null)(PrivateRouteContainer);
